import React from 'react';
import RegistrationPage from '../components/RegistrationPage';
import WhatsAppButton from '../components/WhatsAppButton';

function Register() {
  return (
    <div className="home">
      <RegistrationPage />
      <WhatsAppButton />
    </div>
  );
}

export default Register;
